import {
  CREATE_REVIEW_SUCCESS,
  CREATE_REVIEW_FAILURE,
  GET_ALL_REVIEWS_SUCCESS,
  GET_ALL_REVIEWS_FAILURE,
} from "./ActionTyp";
import api from "../../../config/api";

export const createReview = (resData) => {
  
  return async (dispatch) => {
    try {
      const response = await api.post("/api/reviews/create", resData);

      dispatch({
        type: CREATE_REVIEW_SUCCESS,
        payload: response.data,
      });
      return { success: true };
    } catch (error) {
      const msg =
        error.response?.data?.error ||
        "Could not submit your review. Please try again.";
      dispatch({ type: CREATE_REVIEW_FAILURE, payload: msg });
      return { success: false, error: msg };
    }
  };
};

export const getAllReviews = (productId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/api/reviews/product/${productId}`);

      dispatch({
        type: GET_ALL_REVIEWS_SUCCESS,
        payload: response.data,
      });
      
    } catch (error) {
      dispatch({
        type: GET_ALL_REVIEWS_FAILURE,
        payload: "Could not complete that action. Please try again.",
      });
    }
  };
};
